import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { systemHubCards } from "../../navigation/appNavigation";

const SystemHubPage = () => (
    <SectionHubPage title="System" cards={systemHubCards} />
);

export { SystemHubPage };
